import React from "react";
import ReactDOM from "react-dom";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const DropdownMenuActions = ({
  item,
  onViewProfile,
  onResendInvitation,
  status,
}) => {
  const handleViewProfile = (id) => {
    onViewProfile(id);
  };

  const handleResendInvitation = (id) => {
    onResendInvitation(id);
  };

  const renderDropdownMenu = () => {
    const portalRoot = document.getElementById("portal-root");
    return portalRoot
      ? ReactDOM.createPortal(
        <DropdownMenu>
          <DropdownItem
            onClick={() => handleViewProfile(item.id)}
            className="edit-item-btn"
          >
            <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
            View
          </DropdownItem>
          {status !== "Active" && (
            <DropdownItem
              onClick={() => handleResendInvitation(item.id)}
              className="edit-item-btn"
            >
              <i className="ri-mail-send-fill align-bottom me-2 text-muted"></i>
              Resend Invite
            </DropdownItem>
          )}
        </DropdownMenu>,
        portalRoot
      )
      : null;
  };
  return (
    <ButtonGroup onClick={(e) => e.stopPropagation()}>
      <UncontrolledDropdown className="dropdown d-inline-block">
        <DropdownToggle tag="button" className="btn btn-soft-primary  btn-sm">
          <i className="ri-more-fill align-middle"></i>
        </DropdownToggle>
        {renderDropdownMenu(item)}
      </UncontrolledDropdown>
    </ButtonGroup>
  );
};

export default DropdownMenuActions;
